// Default center coordinates (Rio de Janeiro)
export const DEFAULT_CENTER = {
  lat: -22.9068,
  lng: -43.1729
}

// Maximum distance in kilometers for distance warning
export const MAX_DISTANCE_KM = 0.1

// Maximum geolocation attempts before showing manual input
export const MAX_GEOLOCATION_ATTEMPTS = 3

// Location cache timeout (10 minutes in milliseconds)
export const LOCATION_CACHE_TIMEOUT = 10 * 60 * 1000

// Marker colors
export const MARKER_COLOR_AVAILABLE = '#28a745'
export const MARKER_COLOR_UNAVAILABLE = '#dc3545'

// FontAwesome icon name (passed to <font-awesome-icon :icon="..."/> in
// the dialog). The map marker renders an inline SVG (see MapNavigation.vue)
// because it is built as an HTML string and not a Vue template.
export const OFFLINE_TERMINAL_ICON = 'fa-solid fa-plug-circle-xmark'
